module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDEX OF ")]), _vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HARACTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Cerullo family (the shoemaker’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fernando Cerullo")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("shoemaker.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nunzia Cerullo")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("wife of Fernando and Lila’s mother.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Raffaella Cerullo")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lina")]), _vm._v(", and"), _c('em', {
    staticClass: "italic"
  }), _vm._v("by Elena"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Lila")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rino Cerullo")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("Lila’s older brother, also a shoemaker. ")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rino")]), _vm._v(", also the name of one of Lila’s children.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Other children.")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Greco family (the porter’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elena Greco")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lenuccia ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lenù. ")]), _vm._v("She is the oldest, and after her are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peppe")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Gianni")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elisa.")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("father")]), _vm._v(" is a porter at the city hall.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mother")]), _vm._v(" is a housewife.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Carracci family (Don Achille’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Don Achille Carracci")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("the ogre of fairy tales.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maria Carracci")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("wife of Don Achille.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stefano Carracci")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("son of Don Achille, grocer in the family store.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pinuccia ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alfonso Carracci")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("Don Achille’s two other children.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Peluso family (the carpenter’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alfredo Peluso")]), _vm._v(", carpenter.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Giuseppina Peluso")]), _vm._v(", wife of Alfredo.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pasquale Peluso")]), _vm._v(", older son of Alfredo and Giuseppina, construction worker.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Carmela Peluso")]), _vm._v(", who is also called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carmen")]), _vm._v(", sister of Pasquale, salesclerk in a dry-goods store.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Other children")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Cappuccio family (the mad widow’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Melina")]), _vm._v(", a relative of Lila’s mother, a mad widow.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_vm._v("Melina’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("husband")]), _vm._v(", who unloaded crates at the fruit and vegetable market.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ada Cappuccio")]), _vm._v(", Melina’s daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antonio Cappuccio")]), _vm._v(", her brother, a mechanic.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Other children")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Sarratore family (the railroad worker poet’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Donato Sarratore")]), _vm._v(", conductor.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lidia Sarratore")]), _vm._v(", wife of Donato.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nino Sarratore")]), _vm._v(", the oldest of the five children of Donato and Lidia.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Marisa Sarratore")]), _vm._v(", daughter of Donato and Lidia.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pino")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Clelia")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ciro Sarratore")]), _vm._v(", younger children of Donato and Lidia.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Scanno family (the fruit and vegetable seller’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nicola Scanno")]), _vm._v(", fruit and vegetable seller.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Assunta Scanno")]), _vm._v(", wife of Nicola.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Enzo Scanno")]), _vm._v(", son of Nicola and Assunta, also a fruit and vegetable seller.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Other children")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Solara family (the family of the owner of the Solara bar-pastry shop):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Silvio Solara")]), _vm._v(", owner of the bar-pastry shop.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Manuela")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Solara")]), _vm._v(", wife of Silvio.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Marcello ")]), _vm._v("and"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Michele Solara")]), _vm._v(", sons of Silvio and Manuela.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The Spagnuolo family (the baker’s family):")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Signor Spagnuolo")]), _vm._v(", pastry maker at the bar-pastry shop Solara.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rosa Spagnuolo")]), _vm._v(", wife of the pastry maker.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gigliola Spagnuolo")]), _vm._v(", daughter of the pastry maker.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Other children")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("Gino")]), _vm._v(", son of the pharmacist.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('strong', [_vm._v("The teachers:")])]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maestro Ferraro")]), _vm._v(", teacher and librarian.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Maestra Oliviero")]), _vm._v(", teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Professor Gerace")]), _vm._v(", high school teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Professor Galiani")]), _vm._v(", high school teacher.")]), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nella Incardo")]), _vm._v(", Maestra Oliviero’s cousin, who lives on Ischia.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6604be8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/neapolitan-novels-boxed-set_00002.vue
// module id = 72
// module chunks = 0